import { ToastLevel } from "@metsooutotec/modes-react-components"
import {
    EditingAssetSectionWindow,
    LinerDrawingReference,
    PutLinerLocation,
    PutLinerRegion,
    WearReferencePlane,
} from "features/organizations/asset-sections/models/asset-section-models"

// Hard-coded list of classes to preserve
export enum CssSVGClasses {
    SelectedPath = "selectedPath",
    WsLiner = "ws-liner",
    WsReferenceTemp = "ws-referenceTemp",
    WsRegionTemp = "ws-regionTemp",
    WsRegion = "ws-region",
    WsWearReferencePlaneTemp = "ws-wearReferencePlaneTemp",
    WsHole = "ws-hole",
}

export enum EditorSteps {
    SVGSettings,
    LinersLocation,
    WearReferencePlane,
    HolesLocation,
    LinersDrawingReferences,
}

export interface Position {
    x: number
    y: number
}

export type processSaveRequestProps = {
    requestCallback: (assetSectionFile: File) => Promise<any>
    successCallback?: () => void
    setLoadingAssetImage: (isLoading: boolean) => void
    assetSectionImage: string | null
    errorMessage?: string
    setMessage: (message: string, level?: ToastLevel, timeout?: number) => void
}

export type SaveFunctions = {
    [index: number]: () => void
}

export type OnSvgClickedFunctions = {
    [index: number]: (path: SVGPathElement) => void
}

export type EditBoxFunctions = {
    [index: number]: () => void
}

export type StageButtonsFunctions = {
    [index: number]: () => void
}

export type SvgHandlerType = {
    Parse: (svgString: string) => Document
    Serialize: (svgDocument: Document) => string | null
    SerializeString: (svgDocument: Document) => string | null
}

export interface commonOnSaveProps {
    setLoadingAssetImage: (isLoading: boolean) => void
    assetSectionImage: string | null
    errorMessage: string
    setMessage: (message: string, level?: ToastLevel, timeout?: number) => void
    assetSectionId: string
}
export interface onSaveSettingsAndDetailsprops extends commonOnSaveProps {
    newEditAssetSection: EditingAssetSectionWindow
    setNewEditAssetSection: (liners: EditingAssetSectionWindow) => void
    fetchImage: () => void
}

export interface onSaveLinersProps extends commonOnSaveProps {
    selectedLiners: PutLinerLocation[]
    setSelectedLiners: (liners: PutLinerLocation[]) => void
}

export interface onSaveHolesProps extends commonOnSaveProps {
    selectedholes: PutLinerRegion[]
    setSelectedHoles: (liners: PutLinerRegion[]) => void
}

export interface onSaveLinerDrawingReferencesProps extends commonOnSaveProps {
    selectedLinersDrawingRef: LinerDrawingReference[]
    setSelectedLinersDrawingRef: (liners: LinerDrawingReference[]) => void
}

export interface onSaveWearReferencePlaneProps extends commonOnSaveProps {
    selectedWearReferencePlane: WearReferencePlane[]
    setSelectedWearReferencePlane: (liners: WearReferencePlane[]) => void
}
